import React from 'react';
import axios from "axios";
import {bearerTokenHeader} from "./auth-service";

export async function getListOfReceipts(workOrderId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/insurancehub/extraction/policies/'+ workOrderId + '/receipts');
    return response.data;
}

export async function getPaymentMethods() {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/asserts/waystopay',{
        headers: bearerTokenHeader()
    });
    return response.data;
}